import { render, staticRenderFns } from "./DefectiveSubmit.vue?vue&type=template&id=e5406ede&scoped=true&"
import script from "./DefectiveSubmit.vue?vue&type=script&lang=js&"
export * from "./DefectiveSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5406ede",
  null
  
)

export default component.exports